import { IconDefinition } from '@ant-design/icons-angular';

export const MobileTwoTone: IconDefinition = {
    name: 'mobile',
    theme: 'twotone',
    icon: '<svg viewBox="64 64 896 896" focusable="false"><path d="M744 64H280c-35.3 0-64 28.7-64 64v768c0 35.3 28.7 64 64 64h464c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64zm-8 824H288V136h448v752z" fill="#333" /><path d="M288 888h448V136H288v752zm224-142c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40z" fill="#E6E6E6" /><path d="M472 786a40 40 0 1080 0 40 40 0 10-80 0z" fill="#333" /></svg>'
}